import EnterprisePage from './EnterprisePage'
export default EnterprisePage
